import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromApp from '../store/app.reducer';
import { switchMap, timeout, catchError, filter, first } from 'rxjs/operators';
import { inject } from '@angular/core';
import * as AuthActions from '../auth/store/auth.actions';

export const authEmployeeGuard = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
): Observable<boolean | UrlTree> => {
    const store = inject(Store<fromApp.AppState>);
    const router = inject(Router);

    const hasJwt = !!localStorage.getItem('jwt');

    return store.select(state => state.auth).pipe(
        filter(authState => authState?.authChecked || !!authState?.employee),
        first(),
        switchMap(authState => {
            const isAuth = !!authState?.employee;

            // If we have JWT but no employee and auth hasn't been checked yet, trigger autologin
            if (hasJwt && !isAuth && !authState?.authChecked) {
                store.dispatch(new AuthActions.Autologin());

                // Wait for auth check to complete
                return store.select(state => state.auth).pipe(
                    filter(newAuthState => newAuthState?.authChecked),
                    first(),
                    timeout(60000), // 60 second timeout - avoid logout on slow networks
                    switchMap(finalAuthState => {
                        const finalIsAuth = !!finalAuthState?.employee;
                        if (finalIsAuth) {
                            return of(true);
                        } else {
                            return of(router.createUrlTree(['/login']));
                        }
                    }),
                    catchError(() => {
                        // On timeout or error, redirect to login
                        localStorage.removeItem('jwt');
                        localStorage.removeItem('tokenExpiration');
                        return of(router.createUrlTree(['/login']));
                    })
                );
            }

            if (isAuth) {
                return of(true);
            }

            return of(router.createUrlTree(['/login']));
        })
    );
};